/* @flow */
import React from 'react';

import Message, { GapMessage } from 'entities/Message';
import ChatMessage, { ChatGapMessage } from 'entities/ChatMessage';

export default React.PropTypes.oneOfType([
  React.PropTypes.shape({
    getISO639Locale: React.PropTypes.func.isRequired,
    getBody: React.PropTypes.func.isRequired,
    getSender: React.PropTypes.func.isRequired,
    getSentAt: React.PropTypes.func.isRequired,
    getActivity: React.PropTypes.func.isRequired,
    getUuid: React.PropTypes.func.isRequired,
    getType: React.PropTypes.func.isRequired,
    getMessage: React.PropTypes.func,
    getChatId: React.PropTypes.func,
  }),
  React.PropTypes.instanceOf(GapMessage),
  React.PropTypes.instanceOf(ChatGapMessage),
]);

export type MessageType = Message | ChatMessage | GapMessage | ChatGapMessage;



// WEBPACK FOOTER //
// ./src/chat/lib/MessageInterfacePropType.js